import CalendarEvent from "../Models/CalendarEvent";
import SanitizedDateTime from "../Models/SanitizedDateTime";
import {timeSlots} from "../Models/dateSlots";

const createTimeString = (dateString: string): string => {
    const date = new Date(dateString);
    const time = date.toLocaleTimeString("en-US").split(":");
    const hourSplit = timeSlots[date.getUTCHours() - 4 >= 0 ? date.getUTCHours() - 4 : 0].split(" ");
    const hour = hourSplit[0];
    const min = time[1];
    const period = hourSplit[1];
    return `${hour}:${min} ${period}`;
}

const sanitizeDateAndTime = (event: CalendarEvent): SanitizedDateTime => {
        const startDate = (new Date(event.startDate)).toDateString();
        const startTime = createTimeString(event.startDate);
        const endTime = createTimeString(event.endDate);

        return {
            startDate,
            startTime,
            endTime,
        };
};

export default sanitizeDateAndTime;